/** Message IDs are case-sensitive and scoped to one mailbox by the storage layer. */
export const EMAIL_ID_PATTERN = /^<[^<>\s@]{1,500}@[^<>\s]{1,400}>(?![\s\S])/;
export function emailIds(input: unknown): string[] {
  const values = Array.isArray(input) ? input : [input];
  const ids: string[] = [];
  for (const value of values) {
    if (typeof value !== 'string') continue;
    for (const id of value.slice(0, 100_000).match(/<[^<>\s]+>/g) ?? []) {
      if (EMAIL_ID_PATTERN.test(id) && !ids.includes(id)) ids.push(id);
    }
  }
  return ids.slice(-100);
}
export function emailThread(p: { messageId?: unknown; inReplyTo?: unknown; references?: unknown }) {
  const emailMessageId = emailIds(p.messageId)[0];
  const inReplyTo = emailIds(p.inReplyTo).at(-1);
  const references = emailIds([
    ...(Array.isArray(p.references) ? p.references : [p.references]),
    p.inReplyTo,
  ]);
  return { emailMessageId, inReplyTo, references };
}
export function threadKeys(p: Parameters<typeof emailThread>[0]) {
  const v = emailThread(p);
  return [...new Set([...v.references, ...(v.emailMessageId ? [v.emailMessageId] : [])])];
}
